(function () {
  var MOBILE = window.matchMedia('(max-width: 899.98px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var AUTOPLAY_MS = 2000;

  function buildSlider(card) {
    if (card.dataset.sliderBuilt) return;
    var media = card.querySelector('[data-price-media]');
    var thumbs = card.querySelectorAll('[data-price-thumb]');
    if (!media || thumbs.length < 2) return;
    card.dataset.sliderBuilt = '1';

    var track = document.createElement('div');
    track.className = 'pricing__slider';
    var dots = document.createElement('div');
    dots.className = 'pricing__dots';

    thumbs.forEach(function (btn, i) {
      var slide = document.createElement('div');
      slide.className = 'pricing__slide';
      var img = document.createElement('img');
      img.src = btn.dataset.thumbSrcM || btn.dataset.thumbSrc;
      img.srcset = btn.dataset.thumbSrcsetM || btn.dataset.thumbSrcset || '';
      img.sizes = 'calc(100vw - 32px)';
      img.alt = btn.dataset.thumbAlt || '';
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.setAttribute('data-slider-img', '');
      slide.appendChild(img);
      track.appendChild(slide);
      var dot = document.createElement('span');
      dot.className = 'pricing__dot' + (i === 0 ? ' pricing__dot--on' : '');
      dots.appendChild(dot);
    });

    media.classList.add('pricing__media--has-slider');
    media.appendChild(track);
    media.appendChild(dots);

    var count = thumbs.length, index = 0, timer = null, paused = false;

    function setDot(i) {
      var all = dots.children;
      for (var j = 0; j < all.length; j++) all[j].classList.toggle('pricing__dot--on', j === i);
    }
    function goTo(i) {
      index = (i + count) % count;
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      setDot(index);
    }
    function start() {
      stop();
      if (REDUCED.matches || paused) return;
      timer = setInterval(function () { goTo(index + 1); }, AUTOPLAY_MS);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var deb;
    track.addEventListener('scroll', function () {
      clearTimeout(deb);
      deb = setTimeout(function () {
        index = Math.max(0, Math.min(count - 1, Math.round(track.scrollLeft / track.clientWidth)));
        setDot(index);
      }, 80);
    }, { passive: true });

    track.addEventListener('touchstart', function () { paused = true; stop(); }, { passive: true });
    track.addEventListener('touchend', function () { paused = false; setTimeout(start, 2000); }, { passive: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.25 });
      io.observe(media);
      card._sliderIO = io;
    } else { start(); }

    card._sliderDestroy = function () {
      stop();
      if (card._sliderIO) card._sliderIO.disconnect();
      media.classList.remove('pricing__media--has-slider');
      track.remove(); dots.remove();
      delete card.dataset.sliderBuilt;
      delete card._sliderDestroy;
    };
  }

  function destroySlider(card) { if (card._sliderDestroy) card._sliderDestroy(); }

  function sync() {
    document.querySelectorAll('[data-price-card]').forEach(function (card) {
      MOBILE.matches ? buildSlider(card) : destroySlider(card);
    });
  }

  window.__pricingSliderSync = sync;
  sync();
  if (MOBILE.addEventListener) MOBILE.addEventListener('change', sync);
  else MOBILE.addListener(sync);
  document.addEventListener('shopify:section:load', sync);
})();